export const taskCenter = {
    syrw: 'Mulai dari Tugas, Berakhir untuk Anda',
    zjlbt: 'Dapatkan Bonus USDT Biking yang Tak Henti',
    wdjj: 'Bonus Saya',
    rwsm: 'Deskripsi Tugas',
    rwlb: 'Daftar Tugas',
    jljl: 'Catatan Hadiah',
    klq: 'Dapat Diklaim',
    flzm: 'Gerbang Hadiah Biking',
    dcjl: 'Klaim Saat Tercapai, Hadiah USDT Menemani Perjalanan Anda',
    yjlq: 'Klaim Sekaligus',
    lqcg: 'Klaim Berhasil',
    wdl: 'Belum Login',
    jxz: 'Dalam Proses',
    ylq: 'Telah Diklaim',
    rwjd: 'Progres Tugas',
    xsrw: 'Tugas Pemula',
    hyrw: 'Tugas Kontrak',
    cjrz: 'Verifikasi Dasar',
    gjrz: 'Verifikasi Lanjutan',
    scbbjy: 'Trading Spot Pertama',
    schyjy: 'Trading Kontrak Pertama',
    sccz: 'Setor Pertama',
    schyhz: 'Transfer Kontrak Pertama',
    jyl: 'Volume Trading',
    ylje: 'Jumlah Laba',
    ksje: 'Jumlah Rugi',
    dbkcbzj: 'Margin Open Posisi per Order',
    rjl: 'Volume Deposit',
    dbczje: 'Jumlah Setor per Transaksi',
    rwxq: 'Detail Tugas'
}


// WEBPACK FOOTER //
// ./src/i18n/lang/task/ba.js